var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 4.02778C5.75 2.92474 6.69393 2 8 2C9.30607 2 10.25 2.92474 10.25 4.02778V6.5H5.75V4.02778ZM4.25 6.5V4.02778C4.25 1.9749 5.99236 0.5 8 0.5C10.0076 0.5 11.75 1.9749 11.75 4.02778V6.5H12C13.1046 6.5 14 7.39543 14 8.5V13.5C14 14.6046 13.1046 15.5 12 15.5H4C2.89543 15.5 2 14.6046 2 13.5V8.5C2 7.39543 2.89543 6.5 4 6.5H4.25ZM3.5 8.5C3.5 8.22386 3.72386 8 4 8H12C12.2761 8 12.5 8.22386 12.5 8.5V13.5C12.5 13.7761 12.2761 14 12 14H4C3.72386 14 3.5 13.7761 3.5 13.5V8.5Z",
    fill: "#51566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBlack);
export default __webpack_public_path__ + "static/media/loginBlack.dac2b6c6ced60d3374e84d908d9c6ecd.svg";
export { ForwardRef as ReactComponent };